import listOfChargesList from './listOfChargesList.vue'
import accountStated from "./accountStated.vue"
import summarizingList from "./summarizingList.vue"
import customerListTable from "./customerListTable.vue"
import rateList from "./rateList.vue"
import editRate from "./editRate.vue"
let a = Object.assign({ listOfChargesList, accountStated, summarizingList, customerListTable, rateList, editRate })
export default a